import React, { useEffect, useState } from "react";
import Dropdown from "../../input/Dropdown";
import SearchDropdown from "../../input/SearchDropdown";
import LoadingSpinner from "../../LoadingSpinner";
import { Search } from "react-feather";
import Button from "../../input/Button";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import { searchCustomerConsignee } from "../../../api/customerConsigneeAPI";

const CustomerConsigneeSearch = ({
  setCustomerConsigneeSearchRes,
  setCcoSearchSubmitLoading,
  setCcoSearchClicked,
}) => {
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);

  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const [resetVisible, setResetVisible] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);

  const [customer, setCustomer] = useState("");

  useEffect(() => {
    (async () => {

      const { status, active } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);
    })();
  }, []);

const mapCustomerWise = (data) => {
  

  const grouped = {};

  data.forEach((item) => {
    const key = item.ccoCustomer;

    if (!grouped[key]) {
      grouped[key] = {
        ccoCode: [],
        ccoCustomerName: item.ccoCustomerName,
        ccoConsigneeName: [],
        ccoActiveName: item.ccoActiveName,
        ccoStatusName: item.ccoStatusName,
        ccoCustomer: item.ccoCustomer,
        createdDate: item.createdDate,
      };
    }

    if (item.ccoCode) {
      grouped[key].ccoCode.push(item.ccoCode);
    }

    if (item.ccoConsigneeName) {
      grouped[key].ccoConsigneeName.push(item.ccoConsigneeName);
    }
  });

  return Object.values(grouped).map((item) => ({
    ...item,
    ccoCode: item.ccoCode.join(", "),
    ccoConsigneeName: item.ccoConsigneeName.join(", "),
  }));
};
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setActiveAccordion1(false);
    setResetVisible(true);
    setCcoSearchSubmitLoading(true);
    setCcoSearchClicked(true);

    const response = await searchCustomerConsignee({
      customer: customer,
      status: 2,
      active: 1,
    });

    const mappedData = mapCustomerWise(response);
    const sortedData = [...mappedData].sort(
    (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
  );

    setCustomerConsigneeSearchRes(sortedData);
    setCcoSearchSubmitLoading(false);
  };

  const handleSearchReset = (e) => {
    e.preventDefault();
    setSearchFieldReset([]);
    setCustomer("");
    setStatus(null);
    setActive(null);
  };

  const handleReset = (e) => {
    e.preventDefault();
    handleSearchReset(e);
  };

  return (
    <>
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span>Search</span>
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>

            <i
              className="refresh icon primary button"
              style={{
                display: `${resetVisible ? "flex" : "none"}`,
                cursor: "pointer",
              }}
              onClick={(e) => {
                handleReset(e);
              }}
            ></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {isSearchLoading ? (
            <LoadingSpinner />
          ) : (
            <form className="ui form">
              <h4 className="ui dividing header"></h4>
              <div className="sixteen wide field">
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={false}
                  onClear={() => {
                    setCustomer("");
                  }}
                  onResultSelect={(data) => setCustomer(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "customer",
                  }}
                  label="Customer"
                />
                {/* <Dropdown
                  label="Status"
                  options={statusOptions}
                  placeholder="Status"
                  style={{ height: "20px" }}
                  value={status}
                  onChange={(e, data) => {
                    setStatus(data.value);
                  }}
                />
                <Dropdown
                  label="Active"
                  options={activeOptions}
                  placeholder="Active"
                  style={{ height: "20px" }}
                  value={active}
                  onChange={(e, data) => {
                    setActive(data.value);
                  }}
                /> */}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button
                    template="search"
                    onClick={(e) => {
                      handleSearchSubmit(e);
                    }}
                  />
                  <Button
                    template="searchReset"
                    onClick={(e) => {
                      handleSearchReset(e);
                    }}
                  />
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerConsigneeSearch;
